module.exports = "https://trybtryb-legacy.web.app/img/uploader-video.026ec358.svg";